import { GridOptionsContext } from '@contexts/grid-options'
import { ContentType } from '@entries/content-types'
import ContentfulPageSectionGridLayout from '@entries/contentful-page-section-grid-layout'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPageSectionTabsDesktop: Utils.EntryFC<
  Queries.ContentfulPageSectionTabsDesktopFragment
> = ({ content }) => {
  const numberOfItems = content.contents?.length || 0
  const numberOfColumns = Math.min(numberOfItems, 3) || 1

  return (
    <GridOptionsContext.Provider
      value={{
        col: {
          laptop: numberOfColumns,
        },
      }}
    >
      <Entry
        content={content}
        mapping={{
          [ContentType.ContentfulPageSection]: ContentfulPageSectionGridLayout,
        }}
      />
    </GridOptionsContext.Provider>
  )
}

export const query = graphql`
  fragment ContentfulPageSectionTabsDesktop on ContentfulSection {
    ...ContentfulEntry
    ...ContentfulPageSectionGridLayout
  }
`

export default withDisplayName(
  ContentfulPageSectionTabsDesktop,
  'ContentfulPageSectionTabsDesktop'
)
